/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/18/19
 * Time: 1:09 AM
 */
import React from 'react'
import { Input } from 'semantic-ui-react'
import './LabelInput.css'
import '../LabelButtonsInput/LabelButtonsInput.css'

const App = (props) => (
  <Input
    input={<input onClick={props.inputClick} type={props.type} value={props.value} onChange={props.onChange} disabled={props.disable} className={props.inputClass}/>}
    style={props.type !== "notify" ? {width:'100%',marginBottom:'12px',height:'40px'}:{width:'105%',marginBottom:'12px',height:'40px', marginLeft:'-14px'}}
    label={<label style={{width:props.lblWidth?props.lblWidth : '110px',fontSize:props.lblFontSize}} className="ui label">
      {props.tagText}
      {
        props.required ?
          <span className={"required-field-input"}>*</span>
          :null
      }

    </label>}
    labelPosition='left'
    placeholder={props.placeholder}
  />
);

export default App
